// extracted by mini-css-extract-plugin
module.exports = {"card":"MarkerCard_card__Mk__6","opening":"MarkerCard_opening__DFJvJ","closing":"MarkerCard_closing__LHbhw","content":"MarkerCard_content__p0iYW","close":"MarkerCard_close__0hN1V"};